import * as React from "react";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    todayNodeName,
    workflowRepository,
} from "motw_core/Repositories/WorkflowRepository";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { CompleteAllTodayNodesAsync } from "./ChildNodeName/CompleteNode/Helpers/CompleteAllTodayNodes";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { IRenderChildNodesState } from "./IRenderChildNodesState";

export function CompleteAllTodayNodesLink({
    rootNode,
    state,
}: {
    rootNode: IWorkflowNode;
    state: IRenderChildNodesState;
}) {
    if (rootNode.name !== todayNodeName) {
        return null;
    }

    const [incompleteNodes, setIncompleteNodes] = React.useState<
        IWorkflowNode[]
    >([]);

    React.useEffect(() => {
        workflowRepository
            .GetIncompleteNodes(ClientDataProvider)
            .then((nodes) => setIncompleteNodes(nodes));
    }, [rootNode.id, state.immediateChildren]);

    if (incompleteNodes.length === 0) {
        return null;
    }

    return (
        <div
            style={{
                background: "rgba(0, 0, 0, 0.2)",
                padding: "1px",
                borderRadius: "5px",
                margin: "10px 17px",
                opacity: 0.7,
            }}
        >
            <IconWithText
                iconSuffix={EGlyphicon.ok}
                whenClicked={() => {
                    setIncompleteNodes([]);
                    WithAnimatedProgressBarAsync(CompleteAllTodayNodesAsync);
                }}
                displayAsBlock
            >
                Complete All
            </IconWithText>
        </div>
    );
}
